"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const styles_1 = require("../../styles");
const context_1 = require("../../styles/context");
const keyClass = (0, nano_theme_1.drule)({
    ...styles_1.fonts.get('mono', 'bold', 0),
    d: 'inline-block',
    mr: '0 .1em',
    pd: '.4em .6em',
    bdrad: '.3em',
    lh: '1em',
    fz: '.75em',
    ws: 'pre',
    va: 'middle',
});
const Key = ({ children }) => {
    const styles = (0, context_1.useStyles)();
    const dyn = styles.light
        ? {
            col: styles.g(0),
            // bg: 'rgba(255,255,255,0.7)',
            bg: styles.neutral.fg.pct(0, -0.9, 0.95),
            bd: `1px solid ${styles.g(0.8)}`,
            bdb: `2px solid ${styles.g(0.6)}`,
            bxsh: `0 1px 2px ${styles.g(0.2, 0.1)}`,
        }
        : {
            col: styles.g(0.05),
            // bg: styles.g(0.85),
            bg: styles.neutral.fg.pct(0, -0.7, 0.9),
            bd: `1px solid ${styles.g(0.8)}`,
            bdb: `2px solid ${styles.g(0.55)}`,
            bxsh: `0 1px 2px rgba(0,0,0,0.5)`,
        };
    return React.createElement("kbd", { className: keyClass(dyn) }, children);
};
exports.Key = Key;
